<template>
  <div class="wrapper">
    <span v-if="hasUser">
      {{user.email}}
    </span>
    <span v-else>---</span>
  </div>
</template>

<script>
export default {
  props: {
    model: Object,
  },

  computed: {
    /**
     * @returns {Object|null}
     */
    user() {
      return _.get(this.model, 'user');
    },

    /**
     * @returns {boolean}
     */
    hasUser() {
      return ! _.isEmpty(this.user);
    },
  },
}
</script>

<style scoped>

</style>
